import React from 'react';
import { getPercentFromCountList } from '../../helpers/vote';
import styles from './VoteFullSize.module.css';
import { Percentage } from '../Percentage/Percentage';
import { PercentageBar } from '../PercentageBar/PercentageBar';

const VoteFullSize = ({
  variants,
  title,
  withResults,
  currentState,
  questionFontSize,
  answerFontSize,
  varNumFontSize,
}) => {
  let percentList = getPercentFromCountList(
    (variants || []).map((el) => +el.count)
  );

  const isLong = title?.length > 170;
  const isMore = variants?.length > 6;

  return (
    <div className={styles.container}>
      <div
        className={`${styles.wrapperVars}`}
        style={{
          paddingBottom: isMore ? '2rem' : '4rem',
        }}
      >
        <div
          className={styles.question}
          style={{
            fontSize: isLong
              ? `${0.9 * questionFontSize}rem`
              : `${questionFontSize}rem`,
          }}
        >
          {title}
        </div>

        <div className={styles.vars}>
          {variants?.map((item, i) => (
            <div key={i} className={styles.var}>
              <div className={styles.varTextBlock}>
                <div
                  className={styles.varNumber}
                  style={{
                    fontSize: `${varNumFontSize}rem`,
                    height: `${1.8 * varNumFontSize}rem`,
                    width: `${1.8 * varNumFontSize}rem`,
                    minWidth: `${1.8 * varNumFontSize}rem`,
                  }}
                >
                  {i + 1}
                </div>
                <div
                  className={styles.varTitle}
                  style={{ fontSize: `${answerFontSize}rem` }}
                >
                  {item.comment}
                </div>
              </div>

              <div
                className={styles.varResultBlock}
                style={{ marginLeft: `${1.8 * varNumFontSize + 2}rem` }}
              >
                {currentState === 'S2' && withResults && (
                  <div className={styles.varResult}>
                    {!!percentList[i] && (
                      <PercentageBar width={percentList[i]} />
                    )}
                    <Percentage id={i.toString()} value={percentList[i]} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(VoteFullSize);
